import { useEffect } from 'react';
import { RiCloseFill } from 'react-icons/ri';
import { openChaturChat } from '../../../config/chatur';
import { track } from '../../../config/amplitude';
import { CHATUR_CARD_KEY } from '../../../constants/promotionKeys';
import MeritoButton from '../MeritoButtons/MeritoButtons';
import meritoMark from '../../../assets/images/short-violet-logo.webp';
import whatsappIcon from '../../../assets/images/ipLogos/whatsapp.svg';
import styles from './ChaturPromoCard.module.scss';

const FEATURE = 'chatur_promo';
const SURFACE = 'sidebar_card';

type Props = {
  message: string;
  isExiting: boolean;
  onDismiss: () => void;
};

const ChaturPromoCard = ({ message, isExiting, onDismiss }: Props) => {
  useEffect(() => {
    track('promo_shown', { feature: FEATURE, promo_type: 'infocard', promo_id: CHATUR_CARD_KEY, surface: SURFACE, page_url: window.location.pathname });
  }, []);

  const handleClick = () => {
    track('button_clicked', { feature: FEATURE, cta_text: 'Ask Chatur', section: SURFACE, page_url: window.location.pathname });
    openChaturChat();
  };

  const handleDismiss = () => {
    track('promo_dismissed', { feature: FEATURE, promo_type: 'infocard', promo_id: CHATUR_CARD_KEY, surface: SURFACE, page_url: window.location.pathname });
    onDismiss();
  };

  return (
    <div className={`${styles.card} ${isExiting ? styles.exit : styles.enter}`}>
      <button type="button" className={styles.close} onClick={handleDismiss} aria-label="Dismiss">
        <RiCloseFill size={16} />
      </button>

      <div className={styles.headerRow}>
        <div className={styles.logo}>
          <span className={styles.logoBlock}>
            <img src={meritoMark} alt="Chatur" />
          </span>
          <img src={whatsappIcon} alt="" className={styles.waBadge} />
        </div>
        <p className={styles.status}>
          <span className={styles.dot} />
          Chatur is online
        </p>
      </div>
      <p className={styles.body}>{message}</p>

      <MeritoButton
        type="primary-1"
        btnText="Ask Chatur"
        onClick={handleClick}
        extraStyles={{ padding: '0.5rem' }}
      />
    </div>
  );
};

export default ChaturPromoCard;
